<template>
  <div
    id="forgotPassword"
    class="authentication-container"
    :class="{'authentication-container-mobile': isMobileSize}"
  >

    <!-- LEFT SIDE -->

    <left-side v-if="!isMobileSize"/>

    <!-- RIGHT SIDE -->

    <div class="right-side">

      <!-- STEP 1 -->

      <div
        class="step-1"
        v-if="!response"
      >

        <!-- TITLE -->

        <div class="title">
          <h3 class="title-header">Forgot Password</h3>
        </div>

        <!-- INPUT -->

        <form
          class="content form"
          @submit.prevent="ask"
        >
          <div class="inputs">
            <div class="input-container">
              <label
                for="email"
                class="label"
              >{{ memberMetadata.fields.email.label }}</label>
              <input
                id="email"
                type="email"
                class="primary-input"
                v-model="$v.credentials.email.$model"
                :class="{error: $v.credentials.email.$error}"
              >
              <validation-message
                :validation="$v.credentials.email"
                :metadata="memberMetadata.fields.email"
              />
            </div>
          </div>

          <!-- ACTIONS -->

          <div class="actions">
            <CoreButton
              type="submit"
              :disabled="$v.credentials.$invalid"
              :loading="isLoading"
            >
              Send
            </CoreButton>
          </div>
        </form>

        <!-- GO TO LOGIN -->

        <div class="go-to-login">
          <p>Already have an account?
            <router-link
              to="/login"
              class="link"
            >Log in</router-link>
          </p>
        </div>
      </div>
      <div
        class="step-2"
        v-if="response"
      >
        <div class="title">
          <h3 class="title-header">Send you email</h3>
        </div>
        <div class="content dialog-message">
          <p>We have sent email to <span class="response"> {{ response }} </span> to reset password. After receiving
            the email follow the link provided
            to complete you set new password.
          </p>
        </div>
        <div>
          <p class="p-left-50">
            Haven't got any mails yet? <span
              class="link"
              @click="ask"
            >Resend confirmation email</span>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import server, { createValidator } from './../server'
import { mixin as clickout } from 'vue-clickout'
import { PandaService } from '../utils/request'
import { createToastNotification } from '../utils/toast'
import { WaitStates } from '../utils/vuewait'

const CoreButton = () => import(
  /* webpackChunkName: "CoreButton" */ './../components/Core/CoreButton.vue'
)
const LeftSide = () => import(
  /* webpackChunkName: "LeftSide" */ './../components/LeftSide'
)
const ValidationMessage = () => import(
  /* webpackChunkName: "ValidationMessage" */ './../components/ValidationMessage'
)

export default {
  mixins: [clickout],
  name: 'ForgotPassword',
  data () {
    return {
      organizationId: this.$route.query.organizationId,
      credentials: {
        email: null
      },
      memberMetadata: server.metadata,
      response: null
    }
  },
  validations () {
    return {
      credentials: {
        email: createValidator(this.memberMetadata.fields.email)
      }
    }
  },
  computed: {
    isLoading () {
      return this.$wait.is(WaitStates.FORGOT_PASSWORD_LOADING)
    },
    isMobileSize () {
      return window.innerWidth <= 768
    }
  },
  methods: {
    async ask () {
      const form = {
        email: this.credentials.email
      }
      if (this.organizationId) {
        form['state'] = this.organizationId
      }
      this.$wait.start(WaitStates.FORGOT_PASSWORD_LOADING)
      const { status, statusText, data } = await PandaService({
        url: 'resetpasswordtokens',
        method: 'ASK',
        data: form
      })
      this.$wait.end(WaitStates.FORGOT_PASSWORD_LOADING)
      if (status === 200) {
        createToastNotification(statusText, { type: 'success', position: 'bottom' })
        this.response = data.email
      }
    }
  },
  components: {
    LeftSide,
    ValidationMessage,
    CoreButton
  }
}
</script>
